<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container class="px-10 pt-8">
        <p class="subtitle-1 font-weight-bold mb-0">Update Link</p>
        <v-form v-model="form" class="mt-2">
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="12">
              <v-text-field
                v-model="formTitle"
                label="Link Title"
                prepend-inner-icon="mdi-format-text-variant"
                required
                dense
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="12">
              <v-text-field
                v-model="formUrl"
                label="Link URL"
                prepend-inner-icon="mdi-link"
                required
                :rules="urlRules"
                dense
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text :disabled="!form" @click="finish"
            >Finish</v-btn
          >
          <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      formId: -1,
      formTitle: '',
      formUrl: '',
      form: false,
      dialog: false,
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      urlRules: [(v) => validateUrl(v) || 'The link must be a valid URL']
    }
  },
  methods: {
    open(params) {
      this.formId = params.formId
      this.formTitle = params.formTitle
      this.formUrl = params.formUrl
      this.dialog = true
      //this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async finish() {
      let url = this.formUrl

      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = 'https://' + url
      }

      await this.$store.dispatch('forms/updateFormAction', {
        formId: this.formId,
        formTitle: this.formTitle,
        formUrl: url
      })
      this.dialog = false
      await this.$store.dispatch('forms/fetchFormsAction')
    },
    cancel() {
      this.dialog = false
    }
  }
}

function validateUrl(url) {
  //eslint-disable-next-line
  let re =
    /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/
  return re.test(String(url).toLowerCase())
}
</script>
